import useToastStatus from '@/components/toastStatusGlobal';
import { COMPANY_CONFIG_NAME } from '@/modules/company/entities/enums/company';
import { ParamsToFilterCompanies } from '@/modules/company/entities/interfaces/company';
import CompaniesService from '@/modules/company/services/companiesService';
import { HEALTH_DATA_STEPS } from '@/modules/companyHealthDataConfig/entities/enums/healthData.enums';
import { ListParams } from '@/modules/companyHealthDataConfig/entities/interfaces/healthData.interfaces';
import { useRequestCreation } from '@/shared/hooks/useRequestData/useRequestCreation';
import { cloneDeep } from 'lodash';

const { REACT_APP_COMPANY_HEATH_DATA_CONFIG_VALUE } = process.env;

interface UseHealthDataRequests {
  requestCallback?: () => void;
}

export const useHealthDataRequests = ({ requestCallback }: UseHealthDataRequests) => {
  const { toast } = useToastStatus();

  const { loading: saving, requestCreate: saveManyCompanyConfigs } = useRequestCreation({
    request: (companyIds: string[]) =>
      new CompaniesService().saveManyCompanyConfigs(
        companyIds.map((companyId) => ({
          companyId,
          name: COMPANY_CONFIG_NAME.HEALTH_DATA_INSIGHTS,
          value: REACT_APP_COMPANY_HEATH_DATA_CONFIG_VALUE,
        })),
      ),
    callback: () => {
      requestCallback?.();
      toast('Feito!', 'As empresas selecionadas agora têm acesso aos indicadores de plano de saúde.', 'success');
    },
  });

  const { loading: deleting, requestCreate: deleteManyCompanyConfigs } = useRequestCreation({
    request: (companyIds: string[]) =>
      new CompaniesService().deleteManyCompanyConfigs(
        companyIds.map((companyId) => ({
          companyId,
          name: COMPANY_CONFIG_NAME.HEALTH_DATA_INSIGHTS,
        })),
      ),
    callback: () => {
      requestCallback?.();
      toast(
        'Feito!',
        'Os indicadores de plano de saúde não estão mais disponíveis para as empresas selecionadas.',
        'success',
      );
    },
  });

  const mountPayloadToSearch = (params: ListParams): Partial<ParamsToFilterCompanies> => {
    const { stepHealthData, ...payload }: ListParams = cloneDeep(params);

    if (stepHealthData === HEALTH_DATA_STEPS.DISABLED) {
      payload.withoutConfig = COMPANY_CONFIG_NAME.HEALTH_DATA_INSIGHTS;
    } else {
      payload['companyConfigs.name'] = COMPANY_CONFIG_NAME.HEALTH_DATA_INSIGHTS;
    }

    return payload;
  };

  const getPaginatedList = async (params: ListParams) => {
    const payload = mountPayloadToSearch(params);
    return new CompaniesService().getCompanies(payload);
  };

  return { saving, deleting, saveManyCompanyConfigs, deleteManyCompanyConfigs, getPaginatedList };
};
